type OpenFormChat = () => void;

let openFormChat: OpenFormChat | null = null;

export const registerFormChatAssistantOpen = (open: OpenFormChat) => {
  openFormChat = open;
  return () => {
    if (openFormChat === open) openFormChat = null;
  };
};

export const openFormChatAssistant = () => {
  openFormChat?.();
};
